import { render, staticRenderFns } from "./PriceSettings.vue?vue&type=template&id=0e7e5ab8&"
import script from "./PriceSettings.vue?vue&type=script&lang=ts&"
export * from "./PriceSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports